// adjust breakpoints based on user browser font size
// example: adjustedPx(768) => 768 / 16 * 24 (changed font size) = 1152
export function adjustedPx(px, baseFontSize = 16) {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return (px / baseFontSize) * rootFontSize;
}
export function currency(amount) {
    const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (!isFinite(numericAmount)) {
        return '';
    }
    const formatted = numericAmount.toFixed(2);
    return `${formatted}eur`;
}
